/* eslint-disable react-hooks/exhaustive-deps */
import { createStyles, IconButton, makeStyles, Theme } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { ChartCommonProps, IconButtonWrapper } from '../Common';
import { ChartFilter } from '../ChartComponents';
import { SearchCriteria } from '../SearchCriteria';
import CloseIcon from '@material-ui/icons/Close';
import { formatNumber, getHighestNumberInArray, getMaxSuggestedTick } from '../../helpers/ChartHelper';
// import { DrillDownType } from '../DrillDownType';
import { SelectedItemProps } from '../MattersByStatusChart';
import gql from 'graphql-tag';
import { useQuery } from 'react-apollo';
import { Bar, getElementAtEvent } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ChartEvent, ActiveElement, Chart, Scale, Tick } from 'chart.js';
import zoomPlugin from 'chartjs-plugin-zoom';
import { useScreenshot, createFileName } from 'use-react-screenshot';
import AspectRatioIcon from '@material-ui/icons/AspectRatio';
import GetAppOutlinedIcon from '@material-ui/icons/GetAppOutlined';
import MTooltip from '@material-ui/core/Tooltip';
import { ChartInfo } from '../../components/ChartInfo';
import { VideoModal } from '../../components/VideoModal';
import { DrillDownType } from '../DrillDownType';
import { AIIcon } from '../../components/icons/AIIcon';
import html2canvas from 'html2canvas';
import { AIChartDialog } from '../../components/Dialogs/AIChartDialog';

import { RV_CHART_CLASS, RV_CHART_COLORS, isChartDataEmpty, rvBarDatasetStyle, rvChartAnimation, rvCategoryAxisStyle, rvTooltipStyle, rvValueAxisStyle } from '../chartTheme';
import { ChartHeading } from '../ChartHeading';
import { ChartSkeleton } from '../../components/loading/ChartSkeleton';
import { AnimatedNumber } from '../AnimatedNumber';
import { ChartEmptyState } from '../ChartEmptyState';
import { ChartNotes } from '../ChartNotes';
import InsertChartOutlinedIcon from '@material-ui/icons/InsertChartOutlined';
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, zoomPlugin);

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            position: 'relative',
            paddingBottom: '10px',
            flex: 1,
            display: 'flex',
            flexFlow: 'column',
            maxWidth: '100%',
            maxHeight: '100%',
            height: '100%',
            textAlign: 'center',
            '@media print': {
                display: 'flex',
                flexFlow: 'column',
                alignItems: 'center',
                boxShadow: 'none !important',
            },
        },
        popover: {},
        paper: {},
        radioGroup: {
            flexFlow: 'row wrap',
            justifyContent: 'center',
        },
        closeIcon: {
            color: 'rgb(0, 120, 212)',
        },
        titleContainer: {
            display: 'flex',
            flexFlow: 'column',
            padding: '20px 15px 0px 15px',
        },
        barContainer: {
            padding: '5px 15px 15px 15px',
            minHeight: '350px',
            flex: 1,
            display: 'flex',
            flexFlow: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            maxHeight: '350px',
            maxWidth: 'auto',
            position: 'relative',
            '@media (max-width: 533px)': {
                maxWidth: '350px',
                margin: '0 auto',
            },
            '& .titleWrapper': {
                textAlign: 'center',
                display: 'inline-block',
                width: '100%',
                padding: '15px',
                '& .title': {
                    fontSize: '18px',
                    fontWeight: 600,
                    display: 'block',
                    marginBottom: '15px',
                },
                '& .value': {
                    fontSize: '24px',
                    fontWeight: 600,
                    display: 'block',
                    marginBottom: '15px',
                },
                '& .secondary-title': {
                    fontSize: '16px',
                    fontWeight: 400,
                    display: 'block',
                    marginBottom: '15px',
                },
            },
        },
        loadingWrapper: {
            padding: '20px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
        },
        title: {
            fontSize: 16,
            fontWeight: 600,
            fontFamily: 'inherit',
            marginBottom: 0,
        },
        totalDiv: {
            cursor: 'pointer',
            paddingRight: 5,
        },
        total: {
            fontSize: '2.5rem',
            padding: '10px 0',
            fontWeight: 600,
            cursor: 'pointer',
        },
        span: {
            fontSize: '1rem',
        },
        helpIcon: {
            position: 'absolute',
            left: '5px',
            top: '5px',
            '@media print': {
                display: 'none !important',
            },
        },
        scrollUp: {
            position: 'absolute',
            top: '30px',
            justifyContent: 'center',
            transform: 'translateX(-50%)',
            left: '50%',
            minWidth: '54px',
        },
        scrollDown: {
            position: 'absolute',
            bottom: '90px',
            justifyContent: 'center',
            transform: 'translateX(-50%)',
            left: '50%',
            minWidth: '54px',
        },
        cursor: {
            cursor: 'pointer',
        }
    }),
);

interface EstimatePerformanceChartV2Props extends SelectedItemProps, ChartCommonProps {
    chartFilter?: ChartFilter;
    infoUrl: string;
}

interface ChartState extends MatterFeesPlusWipVsEstimate {
    symbol: string;
    isVideoModalOpen: boolean;
}

export const EstimatePerformanceChartV2: React.FC<EstimatePerformanceChartV2Props> = (props) => {
    const classes = useStyles();

    const chartName = 'Fees + WIP vs Estimate';

    // tslint:disable-next-line:no-any
    const chartRef = React.useRef<any>();

    // tslint:disable-next-line:no-any
    const entireChartRef = React.useRef<any>();

    const [base64Data, setBase64Data] = useState<string | ArrayBuffer | null>(null);
    
    const [isAIDialogOpen, setIsAIDialogOpen] = useState<boolean>(false);

    const [isBlobGenerating, setIsBlobGenerating] = useState<boolean>(false);

    const takeScreenShot = useScreenshot({
        type: 'image/jpeg',
        quality: 1.0
    })[1];

    const currencySymbolQuery = useQuery<CurrencySymbolData>(CURRENCY_SYMBOL_QUERY);

    const totalDebtOwingQuery = useQuery<MatterFeesPlusWipVsEstimateData, MatterFeesPlusWipVsEstimateDataParams>(MatterFeesPlusWipVsEstimateDataQuery, {
        variables: {
            entityType: props.chartFilter?.entityType,
            entityGuid: props.chartFilter?.entityGuid,
            responsibility: props.chartFilter?.responsibility,
            showAllRecords: props.showAllRecords
        }
    });
    
    const [state, setState] = useState<ChartState>({
        symbol: '$',
        isVideoModalOpen: false,
        exceedingEightyFive: 0,
        exceedingHundred: 0,
        exceedingSixty: 0,
        lessThanSixty: 0,
        mattersCount: 0,
        mattersWithNoEstimate: 0,
        mattersWithNoEstimateBilledFee: 0,
        mattersWithNoEstimateUnBilledFee: 0,
    });

    useEffect(() => {
        if (totalDebtOwingQuery.data && totalDebtOwingQuery.data.statistics && !totalDebtOwingQuery.loading && !totalDebtOwingQuery.error) {
            setState((prevState) => {
              
                const { 
                    exceedingEightyFive,
                    exceedingHundred,
                    exceedingSixty,
                    lessThanSixty,
                    mattersCount,
                    mattersWithNoEstimate,
                    mattersWithNoEstimateBilledFee,
                    mattersWithNoEstimateUnBilledFee
                } = totalDebtOwingQuery.data!.statistics.matter.matterFeesPlusWipVsEstimate;

                return {
                    ...prevState,
                    exceedingEightyFive,
                    exceedingHundred,
                    exceedingSixty,
                    lessThanSixty,
                    mattersCount,
                    mattersWithNoEstimate,
                    mattersWithNoEstimateBilledFee,
                    mattersWithNoEstimateUnBilledFee,
                };
            });
        }

        // tslint:disable-next-line: align
    }, [totalDebtOwingQuery.loading, totalDebtOwingQuery.error, totalDebtOwingQuery.data]);

    useEffect(() => {
        if (currencySymbolQuery.data && currencySymbolQuery.data.options && !currencySymbolQuery.loading && !currencySymbolQuery.error) {
            setState((prevState) => {
                return {
                    ...prevState,
                    symbol: currencySymbolQuery.data!.options.currencySymbol.symbol,
                };
            });
        }

        // tslint:disable-next-line: align
    }, [currencySymbolQuery.loading, currencySymbolQuery.error, currencySymbolQuery.data]);

    const onCloseChart = () => {
        if (props.onCloseChart) {
            return props.onCloseChart(`isEstimatePerformanceChartOpen`);
        }
    };

    const onMaximize = () => {
        if (props.onMaximize) {
            props.onMaximize();
        }
    };

    // tslint:disable-next-line: no-any
    const onDownload = (name: string, extension: string = 'jpg') => (image: any) => {
        const a = document.createElement('a');
        a.href = image;
        a.download = createFileName(extension, name);
        a.click();
    };

    const onDownloadScreenshot = () => {
        setTimeout(() => {
            takeScreenShot(entireChartRef.current).then(onDownload('Total Debt Owing - Pie Chart'));
            // tslint:disable-next-line: align
        }, 500);
    };

    const onPan = (context: { chart: Chart }) => {
        chartRef.current.options.scales.x.min = 0;
        chartRef.current.update();
    };

    const onAIGeneratedSuggestion = async (event: any) => {

        setIsBlobGenerating(true);

        event.preventDefault();
        event.stopPropagation();
       
        if (entireChartRef && entireChartRef.current) {
            const canvas = await html2canvas(entireChartRef.current);
            canvas.toBlob((blob) => {
                if (blob) {
                    const reader = new FileReader();
                    reader.readAsDataURL(blob);
                    reader.onloadend = async () => {
                        const tempBase64data = reader.result;
                        // console.log(tempBase64data); // This is your image blob string
                        setBase64Data(tempBase64data);
                        setIsAIDialogOpen(true);
                    };
                }
            });
        }

        setIsBlobGenerating(false);
    };

    const handleNoEstimates = () => {
        if (props.getSelectedItem) {
            const searchCriterias = new Array<SearchCriteria>();

            searchCriterias.push({ property: 'NoEstimatedCosts', operator: 'eq', comparison: '0' });

            props.getSelectedItem(searchCriterias, false, 'Fees + WIP vs Estimate', DrillDownType.matterSummaryDrilldown, 'Matters');
        }
    };

    const chartControllerComponent = () => {
        return (
            <>
                <IconButtonWrapper aria-label="close">
                    <ChartInfo 
                        description={props.description}
                        fontSize={props.showAllRecords ? 'large' : 'medium'}
                        className={`${classes.helpIcon} rv-chart-help`}
                    />
                    {props.isAIFeatureEnabled && (
                        <MTooltip title="AI Assistant">
                            <IconButton 
                                disabled={isBlobGenerating}
                                size={props.showAllRecords ? 'medium' : 'small'}
                                onClick={onAIGeneratedSuggestion}
                            >
                                <AIIcon 
                                    color="primary"
                                    fontSize={props.showAllRecords ? 'large' : 'medium'}
                                />
                            </IconButton>
                        </MTooltip>
                    )}
                    {props.showAllRecords && (
                        <IconButton size="medium" onClick={onDownloadScreenshot}>
                            <GetAppOutlinedIcon color="primary" fontSize="large" />
                        </IconButton>
                    )}
                    {!props.showAllRecords && props.onMaximize && (
                        <MTooltip title="Expand chart">
                            <IconButton aria-label="maximize" onClick={onMaximize} size="small">
                                <AspectRatioIcon />
                            </IconButton>
                        </MTooltip>
                    )}
                    <IconButton aria-label="close" onClick={onCloseChart} size={props.showAllRecords ? 'medium' : 'small'}>
                        <CloseIcon className={classes.closeIcon} fontSize={props.showAllRecords ? 'large' : 'medium'} />
                    </IconButton>
                </IconButtonWrapper>
            </>
        );
    };

    const handleTotalClick = () => {
        if (props.getSelectedItem) {
            const searchCriterias = new Array<SearchCriteria>();
            searchCriterias.push({ property: 'EstimatedCosts', operator: 'gt', comparison: '0' });

            props.getSelectedItem(searchCriterias, false, 'Fees + WIP vs Estimate', DrillDownType.matterSummaryDrilldown, 'matters');
        }
    };

    const onToggleVideo = () => {
        setState((prevState) => {
            return {
                ...prevState,
                isVideoModalOpen: !prevState.isVideoModalOpen
            };
        });
    };

    const onHover = (event: ChartEvent, elements: ActiveElement[], chart: Chart) => {
        (event?.native?.target as HTMLElement).style.cursor = elements.length > 0 ? 'pointer' : 'auto';
    };
    
    if (totalDebtOwingQuery.loading || currencySymbolQuery.loading) {
        return (
            <ChartSkeleton variant="bars" />
        );
    }

    return (
        <>
            {isAIDialogOpen && (
                <AIChartDialog 
                    fullWidth={true}
                    maxWidth="md"
                    open={isAIDialogOpen}
                    onClose={() => setIsAIDialogOpen(false)}
                    data={base64Data}
                    query={props.aiPrompt || 'Give me recommendations on this and highlight any exceptions or concerns'}
                    accessSubType={chartName}
                    layoutId={props.layoutId}
                />
            )}
            {state.isVideoModalOpen && props.infoUrl && <VideoModal open={state.isVideoModalOpen} onClose={onToggleVideo} url={props.infoUrl} />}
            <div className={`${classes.root} ${RV_CHART_CLASS}${isChartDataEmpty([state.exceedingHundred, state.exceedingEightyFive, state.exceedingSixty, state.lessThanSixty]) ? ' rv-chart--empty' : ''}`} ref={entireChartRef}>
                {chartControllerComponent()}
                <div className={classes.titleContainer}>
                    <ChartHeading icon={<InsertChartOutlinedIcon />} title={chartName} />
                    <div className={`${classes.total} h2`} onClick={handleTotalClick}>
                        <AnimatedNumber value={state.mattersCount} format={(amount) => `${formatNumber(amount)}`} />
                    </div>
                    <div className={classes.title}>Current Matters with Estimates</div>
                </div>
                <div className={classes.barContainer}>
                    <Bar
                        ref={chartRef}
                        // tslint:disable-next-line: no-any
                        onClick={(event: React.MouseEvent<any>) => {
                            const _data = getElementAtEvent(chartRef.current, event);
                            if (_data.length > 0 && props.getSelectedItem) {
                                const _index = getElementAtEvent(chartRef.current, event)[0].index;

                                const item = ['Exceeding 100%', 'Exceeding 85%', 'Exceeding 60%', 'Less Than 60%'][_index];

                                const searchCriterias = new Array<SearchCriteria>();

                                if (item === 'Exceeding 100%') {
                                    searchCriterias.push(
                                        { property: 'FeeWIPVsEstimate', operator: 'gt', comparison: '100' },
                                        // { property: 'InProgress', operator: 'eq', comparison: '1' }
                                    );
                                } else if (item === 'Exceeding 85%') {
                                    searchCriterias.push(
                                        { property: 'FeeWIPVsEstimate', operator: 'gt', comparison: '85' },
                                        { property: 'FeeWIPVsEstimate', operator: 'lteq', comparison: '100' },
                                        // { property: 'InProgress', operator: 'eq', comparison: '1' }
                                    );
                                } else if (item === 'Exceeding 60%') {
                                    searchCriterias.push(
                                        { property: 'FeeWIPVsEstimate', operator: 'gt', comparison: '60' },
                                        { property: 'FeeWIPVsEstimate', operator: 'lteq', comparison: '85' },
                                        // { property: 'InProgress', operator: 'eq', comparison: '1' }
                                    );
                                } else if (item === 'Less Than 60%') {
                                    searchCriterias.push(
                                        { property: 'FeeWIPVsEstimate', operator: 'lteq', comparison: '60' },
                                        { property: 'FeeWIPVsEstimate', operator: 'gteq', comparison: '1' },
                                        // { property: 'InProgress', operator: 'eq', comparison: '1' }
                                    );
                                }

                                props.getSelectedItem(
                                    searchCriterias,
                                    false,
                                    'Fees + WIP vs Estimate',
                                    DrillDownType.matterSummaryDrilldown,
                                    'matters',
                                );
                            }
                        }}
                        data={{
                            labels: ['Exceeding 100%', 'Exceeding 85%', 'Exceeding 60%', 'Less Than 60%'],
                            datasets: [
                                {
                                    label: 'Matters',
                                    ...rvBarDatasetStyle([RV_CHART_COLORS.red, RV_CHART_COLORS.amber, RV_CHART_COLORS.primary, RV_CHART_COLORS.primarySoft]),
                                    data: [state.exceedingHundred, state.exceedingEightyFive, state.exceedingSixty, state.lessThanSixty],
                                },
                            ],
                        }}
                        options={{
                            onHover: onHover,
                            indexAxis: 'y' as const,
                            animation: rvChartAnimation(),
                            elements: { bar: { borderWidth: 0 } },
                            responsive: true,
                            maintainAspectRatio: false,
                            scales: {
                                x: {
                                    grid: rvValueAxisStyle.grid,
                                    // beginAtZero: true,
                                    suggestedMax: getMaxSuggestedTick(
                                        getHighestNumberInArray([state.exceedingHundred, state.exceedingEightyFive, state.exceedingSixty, state.lessThanSixty]),
                                        6,
                                    ),
                                    beginAtZero: true,
                                    ticks: {
                                        ...rvValueAxisStyle.ticks,
                                        autoSkip: false,
                                        callback: function (this: Scale, tickValue: number, index: number, ticks: Tick[]) {
                                            return `${formatNumber(tickValue)}`;
                                        },
                                    },
                                },
                                y: {
                                    grid: rvCategoryAxisStyle.grid,
                                    // min: 0,
                                    // max: 9 // minimum display
                                    ticks: {
                                        ...rvCategoryAxisStyle.ticks,
                                        autoSkip: false,
                                    },
                                },
                            },
                            plugins: {
                                legend: {
                                    position: 'bottom' as const,
                                    display: false,
                                },
                                title: {
                                    display: false,
                                    text: `Fees + WIP vs Estimate`,
                                },
                                zoom: {
                                    pan: {
                                        enabled: false,
                                        onPan: onPan,
                                    },
                                    zoom: {
                                        wheel: {
                                            enabled: false,
                                        },
                                    },
                                    // limits: {
                                    //   y: { min: 0, max: 9 },
                                    // },
                                },
                                tooltip: {
                                    ...rvTooltipStyle,
                                    callbacks: {
                                        // tslint:disable-next-line: no-any
                                        label: function (context: any) {
                                            const {
                                                //   dataIndex,
                                                //   label,
                                                formattedValue,
                                                dataset,
                                            } = context;

                                            return `${dataset.label} ${formattedValue}`;
                                        },
                                    },
                                },
                            },
                        }}
                    />
                    {isChartDataEmpty([state.exceedingHundred, state.exceedingEightyFive, state.exceedingSixty, state.lessThanSixty]) && (
                        <ChartEmptyState title="No data" hint="Nothing to show for this selection." />
                    )}
                </div>
                <div>
                    <span className={classes.cursor} onClick={() => handleNoEstimates()}>{formatNumber(state.mattersWithNoEstimate)}</span> matters with no
                    estimates representing
                </div>
                <div className={classes.span}>{`${state.symbol}${formatNumber(state.mattersWithNoEstimateBilledFee)} in billed fees, ${state.symbol}${formatNumber(
                    state.mattersWithNoEstimateUnBilledFee,
                )} in WIP.`}</div>
                <ChartNotes notes={['Fees only, disbursements are not included']} />
            </div>
        </>
    );
};

export interface CurrencySymbolData {
    options: Options;
}

export interface Options {
    currencySymbol: CurrencySymbol;
}

export interface CurrencySymbol {
    symbol: string;
}

export const CURRENCY_SYMBOL_QUERY = gql`
    query CurrencySymbol {
        options {
            currencySymbol {
                symbol
            }
        }
    }
`;

export type MatterFeesPlusWipVsEstimateDataParams = {
    entityType?: number;
    entityGuid?: string, 
    responsibility?: number, 
    showAllRecords?: boolean
};

export type MatterFeesPlusWipVsEstimateData = {
    statistics: Statistics;
};

export type Data = {
    statistics: Statistics;
}

export type Statistics = {
    matter: Matter;
}

export type Matter = {
    matterFeesPlusWipVsEstimate: MatterFeesPlusWipVsEstimate;
}

export type MatterFeesPlusWipVsEstimate = {
    mattersWithNoEstimateBilledFee:   number;
    mattersWithNoEstimateUnBilledFee: number;
    mattersCount:                     number;
    mattersWithNoEstimate:            number;
    exceedingHundred:                 number;
    exceedingEightyFive:              number;
    exceedingSixty:                   number;
    lessThanSixty:                    number;
}

const MatterFeesPlusWipVsEstimateDataQuery = gql`
    query MatterFeesPlusWipVsEstimateData($entityType: Int, $entityGuid: String, $responsibility: Int) {
        statistics {
            matter {
                matterFeesPlusWipVsEstimate(entityType: $entityType, entityGuid: $entityGuid, responsibility: $responsibility) {
                    mattersWithNoEstimateBilledFee
                    mattersWithNoEstimateUnBilledFee
                    mattersCount
                    mattersWithNoEstimate
                    exceedingHundred
                    exceedingEightyFive
                    exceedingSixty
                    lessThanSixty
                }
            }
        }
    }
`;
